export const PoolCalculateByPolicy = ({

    MONTHLY: "MONTHLY",
    DAILY: "DAILY",
    DAYS_14: "14-DAYS",
    DAYS_30: "30-DAYS",
})